const accordeonWrapper = document.querySelectorAll('.onlr-faq-wrapper');

accordeonWrapper.forEach(wrap => {
    const accordeonList = wrap.querySelectorAll('.accordeon-wrapper'), toggleAll = wrap.querySelector('.view-more .wp-element-button')
    const maxDisplay = 4;

    if(accordeonList.length <= maxDisplay) {
        toggleAll.style.display = 'none';
        return;
    }  
    
    toggleAll.addEventListener('click', () => {
        const isHidden = wrap.querySelector('.hide-accordeon')

        accordeonList.forEach((el, i) => {

            if(isHidden) {
                el.classList.remove('hide-accordeon');
                toggleAll.innerText = 'Voir moins de questions';
            }
            else if(i > maxDisplay - 1) {
                el.classList.add('hide-accordeon');
                toggleAll.innerText = 'Voir plus de questions';
            }

        });
    });

    accordeonList.forEach((el, i) => {
        if(i > maxDisplay - 1) el.classList.add('hide-accordeon');
    });
});